import React, { createContext, useContext, useState, useEffect } from 'react';
import { settingsAPI } from '../utils/api';

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    company_name: 'Your Company',
    company_tagline: '',
    address: '',
    phone1: '', phone2: '',
    email1: '', email2: '',
    website: '',
    footer_note: 'Thank you for your business!',
    bill_prefix: 'BILL',
    receipt_prefix: 'RCP',
    currency: 'BDT',
    primary_color: '#2563eb',
    accent_color: '#93c5fd',
    company_logo: null,
  });
  const [loading, setLoading] = useState(true);
useEffect(() => {
  const token = localStorage.getItem('bp_token');
  if (!token) { setLoading(false); return; }

  settingsAPI.get()
    .then(res => { if (res.data) setSettings(res.data); })
    .catch(() => {})
    .finally(() => setLoading(false));
}, []);

 

  return (
    <SettingsContext.Provider value={{ settings, setSettings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
